import axios, { AxiosResponse } from "axios";

const API_URL = process.env.REACT_APP_API_URL;

interface BrandResponse {
  brand: any;
}

class Brand {
  create = async (brand: any) => {
    await axios.post<BrandResponse>(`${API_URL}item-brand`, brand)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  edit = async (brand: any, code: any) => {
    await axios.put<BrandResponse>(`${API_URL}item-brand/${code}`, brand)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<BrandResponse>(`${API_URL}item-brand/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.brand;
  };

  getAll = async () => {
    const response = await axios.get<BrandResponse>(`${API_URL}item-brand`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.brand;
  };
}

export default new Brand();
